import React from "react";
import { FormattedMessage } from "react-intl";
export default function ProfileLanguageChange(props) {
    if (props.language === "Spanish") {
        return (<FormattedMessage id="forms.profile.language.changeToSpanish" defaultMessage="Please change your browser settings to Spanish"/>);
    }
    return (<FormattedMessage id="forms.profile.language.changeToEnglish" defaultMessage="Please change your browser settings to English"/>);
}



// WEBPACK FOOTER //
// ./src/assets/scripts/components/forms/secure/profile/ProfileForm/ProfileLanguageInputs/ProfileLanguageChange.tsx